<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="排班名称">
          <el-input placeholder="请输入排班名称" v-model="formInline.search">
           
          </el-input>
        </el-form-item>

        <el-form-item label="学生姓名/手机号/ID">
          <el-input placeholder="请输入学生姓名/手机号/ID" v-model="formInline.user_name">
          </el-input>
        </el-form-item>
        <el-form-item label="教师名称/ID">
          <el-input placeholder="请输入教师名称/ID" v-model="formInline.name">
          </el-input>
        </el-form-item>

        <el-form-item label="类型：" prop="type" >
      <el-select v-model="formInline.type" >
        <template >
          <el-option :value="-1" label="全部"></el-option>
          <el-option :value="1" label="正课（单词课）"></el-option>
          <el-option :value="2" label="正课（语法阅读课）"></el-option>
          <el-option :value="3" label="复习课"></el-option>
        
        </template>
      </el-select>
    </el-form-item>  

        <el-form-item >
          <el-button   type="primary" icon="el-icon-search" @click="getData">查询</el-button>
          <el-button    icon="el-icon-search" @click="reast">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" type="success" @click="onExport"  >导出</el-button>
       
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" @selection-change="handleSelectionChange"  border style="width: 100%" v-loading="loading">
            <el-table-column prop="term" label="课程标题"></el-table-column>
            <el-table-column prop="name" label="课程名称"></el-table-column>
            <el-table-column prop="type_val" label="课程类型"></el-table-column>
            <el-table-column prop="user.nickName" label="学生"></el-table-column>
            <el-table-column prop="user.mobile" label="学生联系方式"></el-table-column>
            <el-table-column prop="remark" label="上课时间段">
              <template slot-scope="scope">
               <div style="height: 80px;width:210px; overflow-x:auto;">
                  <div v-for="(item,index) in scope.row.time" :key="index">
                  {{ item.val.week_val }}-{{ item.val.time_start }}-{{ item.val.time_end }} 
                  </div>
          

               </div>
              </template>
            </el-table-column>
            <el-table-column prop="coc.name" label="教师"></el-table-column>
            <el-table-column prop="datea" label="预约开始上课时间"></el-table-column>
            <el-table-column prop="user.subsc_time" label="剩余修改次数"></el-table-column>
       

          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :workforce_id="workforce_id"  v-if="open_edit"   @close="closeEdit"></Edit>
  </div>
</template>

<script>
  import WorkforceApi from '@/api/workforce.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';
  import qs from 'qs'
  export default {
    components: {
      Add,
      Edit
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:"",
          name:"",
          term:"",
          type:-1,
          user_name:""
        },

        open_add:false,
        open_edit:false,
        workforce_id:"",
              /*选中的*/
      multipleSelection: [],
      /*选择的会员列表*/
      select_list: [],
      };
    },
    created() {
      this.formInline.name = this.$route.query.coc_id;
      /*获取列表*/
      this.getTableList();
    },
    methods: {
      onExport: function() {
      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/plus.workforce.workforce.index/export?' + qs.stringify(this.formInline);
    },
       /*选择会员*/
    handleSelectionChange(e) {
      console.log(e);
      this.multipleSelection = e;
    },
          /* 设置默认 */
    isDefaultChange(row) {
      let self = this
      self.$confirm('是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.loading = true;
        let status = 1;
        if(row.status){
          status = 1;
        }else{
          status = 0;
        }
        WorkforceApi.setStatus({workforce_id: row.workforce_id,status:status}, true).then(data => {
          console.log(data)
          if (data.code === 1) {
            self.loading = false;
            self.$message({
              message: '恭喜你，操作成功',
              type: 'success'
            });
            self.getTableList();
          } else {
            self.loading = false;
          }
        }).catch(error => {
          self.loading = false;
        });
      }).catch(() => {
    
      })
    },
    isDefaultChangef(row) {
      let self = this
      self.$confirm('是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.loading = true;
        let fstatus = 1;
        if(row.status){
          fstatus = 1;
        }else{
          fstatus = 0;
        }
        WorkforceApi.setStatusf({workforce_id: row.workforce_id,fstatus:fstatus}, true).then(data => {
          console.log(data)
          if (data.code === 1) {
            self.loading = false;
            self.$message({
              message: '恭喜你，操作成功',
              type: 'success'
            });
            self.getTableList();
          } else {
            self.loading = false;
          }
        }).catch(error => {
          self.loading = false;
        });
      }).catch(() => {
    
      })
    },
      reast(){
        this.  formInline={
          search:"",
          name:"",
          term:""
        }
        this.getTableList();
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        WorkforceApi.record(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
            for(var i=0;i<self.tableData.length;i++){
              self.tableData[i].status = self.tableData[i].status==0?false:true;
            }
           
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.workforce_id = row.workforce_id;
        this.open_edit = true
      },
      deleteAllClick(){
        if(this.multipleSelection.length <= 0){
          self.$message({
                    message: '请选择要删除的排班',
                    type: 'info'
                  });
                  return;
        }
        var ids = [];
        this.multipleSelection.forEach(function(res){
          ids.push(res.workforce_id);
        })
        let self = this;
        self
          .$confirm('此操作将永久删除这些记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            if(Array.isArray(ids)){
              ids = JSON.stringify(ids);
            }
            WorkforceApi.del(
              {
                workforce_id: ids
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      
      },
      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            WorkforceApi.del(
              {
                workforce_id:  JSON.stringify([ row.workforce_id])
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/workforce/workforce/record.vue